import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicCartUpdateItemRequest {
  @jsonMember(Number)
  public readonly quantity!: number;

  public constructor(
    private readonly data: {
      quantity: number;
    },
  ) {
    this.quantity = this.data.quantity;
  }
}
